import { useCallback, useEffect, useState } from "react";
import { Award, Check, RefreshCw, X } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const levelLabels = {
  level_1: "1. Seviye",
  level_2: "2. Seviye",
  level_3: "3. Seviye",
  mastery: "Ustalık Seviyesi",
};

export default function PractitionerApprovalsPage() {
  const [data, setData] = useState({ items: [], pending_count: 0 });
  const [error, setError] = useState("");
  const [working, setWorking] = useState("");

  const load = useCallback(async () => {
    setError("");
    try {
      const { data: result } = await api.get("/practitioner-approvals");
      setData(result);
    } catch (e) {
      setError(formatApiError(e));
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const decide = async (userId, decision) => {
    setWorking(userId);
    try {
      await api.patch(`/practitioner-approvals/${userId}`, { decision });
      setData((current) => ({
        items: current.items.filter((item) => item.id !== userId),
        pending_count: Math.max(0, current.pending_count - 1),
      }));
    } catch (e) {
      setError(formatApiError(e));
    } finally {
      setWorking("");
    }
  };

  return (
    <div className="p-3 sm:p-5 lg:p-6 max-w-[1000px]">
      <div className="flex items-start justify-between gap-3 mb-3 sm:mb-5">
        <div>
          <div className="flex items-center gap-2"><Award className="w-5 h-5" /><h1 className="text-[20px] font-semibold">Uygulayıcı Onayları</h1></div>
          <p className="text-[12px] text-pleiades-slate mt-1.5">Kullanıcıların beyan ettiği Pleiades uygulayıcılık seviyelerini inceleyin.</p>
        </div>
        <button onClick={load} className="h-9 px-3 border border-pleiades-border bg-white text-[12px] flex items-center gap-2"><RefreshCw size={14} /> Yenile</button>
      </div>
      {error && <div className="mb-4 bg-red-50 text-red-700 border border-red-200 px-4 py-3 text-[12px]">{error}</div>}
      {data.items.length === 0 ? (
        <div className="py-16 bg-white border border-dashed border-pleiades-border text-center">
          <Award className="w-7 h-7 mx-auto text-pleiades-muted mb-3" />
          <div className="text-[13px] font-medium">Bekleyen uygulayıcı başvurusu yok</div>
        </div>
      ) : (
        <div className="bg-white border border-pleiades-border">
          {data.items.map((item) => (
            <div key={item.id} className="grid md:grid-cols-[1fr_180px_220px] gap-3 sm:gap-4 items-center px-3 sm:px-5 py-3 sm:py-4 border-b border-pleiades-border last:border-b-0">
              <div>
                <div className="text-[13px] font-semibold">{item.name}</div>
                <div className="text-[11px] text-pleiades-muted mt-1">{item.email}</div>
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-wider text-pleiades-muted">Talep edilen seviye</div>
                <div className="text-[13px] font-medium mt-1">{levelLabels[item.practitioner_requested_level]}</div>
                <div className="text-[10px] text-pleiades-muted mt-1">{new Date(item.practitioner_submitted_at).toLocaleString("tr-TR")}</div>
              </div>
              <div className="sticky bottom-2 z-10 flex gap-2 bg-white/95 py-1 md:static md:bg-transparent md:py-0 md:justify-end">
                <button disabled={working === item.id} onClick={() => decide(item.id, "reject")}
                  className="h-9 px-3 border border-red-200 text-red-700 text-[12px] flex items-center gap-1.5 disabled:opacity-40"><X size={14} /> Reddet</button>
                <button disabled={working === item.id} onClick={() => decide(item.id, "approve")}
                  className="h-9 px-3 bg-emerald-700 text-white text-[12px] flex items-center gap-1.5 disabled:opacity-40"><Check size={14} /> Onayla</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
